/**
 * Returns a string in underscore format
 */
export function parseToUnderscore(str: string): string {
  if (!str || typeof str !== 'string') {
    return '';
  }

  return str
    .split(/(?=[A-Z])/)
    .join('_')
    .toLowerCase();
}

export function capitalizeWords(str: string): string {
  return str.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}